<template>
<div class="main-in">
    <div class="container" v-cloak>
        <div is='titlebox' :nav='JSON.parse(nav)' ></div>
        <div class="content">
            <div class="words min-h">
                <strong v-if='info.title'>{{info.title}}</strong>
                <ul>
                    <li v-if='info.source'>来源：{{info.source}}</li>
                    <li v-if='info.author'>作者：{{info.author}}</li>
                    <li v-if='info.createTime'>发布时间：{{info.createTime}}</li>
                </ul>
                <div class="bannerbox">
                    <div is='phoneBooks_img' :id='id'></div>
                </div>
                <div class="words2 pt-4">
                    <div v-html="$util.regImg(info.content)" v-if='info.content'></div>
                </div>
            </div>
            <div v-if='info.file' class="downbox">
                <div v-if='type!=32'>
                    <span class="downicon pinter" v-for='(item,ind) in info.file.split(",")' :key='ind' :title="item" @click="openUrl($imgUrl+item)">
                    附件下载
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>
<script>
import phoneBooks_img from '@/components/phoneBooks/phoneBooks_img.vue'
export default {
    components:{phoneBooks_img},
    computed:{
        nav:function(){
            var tier=2;
            var type=this.$route.query.type
            if((type>=14)&&(type<=32)&&type!=24&&type!=31){ 
                tier=3
            }
            if ((type >= 36) && (type <= 48)) {
                tier = 3
            }
            var arr=this.$util.getTopNav(this.title, this.$route.query.type,this.$route.query.isPrivate,tier)
            return JSON.stringify(arr)
        },
    },
    data() {
        return {
            type:this.$route.query.type,
            title:this.$route.query.title,
            msgType:'',
            pageNo:1,
            info:{},
            id:'',
        };
    },
    created(){
        this.typeIs()
    },
    methods:{
        openUrl(url){
            window.open(url)
        },
        typeIs(){
            this.title=this.$util.getDetailTitle(this.type)
            this.type=this.type*1
            if(this.type==7){ //'图集详情'
                this.id=this.$route.query.id
                this.getInfo(this.id)
            }
           
        },
        getInfo(id ){///web/home/getLasDetails?id=
            // var params={
            //     pictureId:id,
            //     pageNo:this.pageNo,
            //     pageSize:4
            // }
            this.$get('/web/home/getLasDetails?id='+id).then(res=>{ 
                if(res.success){ 
                    this.info=res.result
                    this.info.title=res.result.pictureTitle
                    this.info.content=res.result.pictureContent
                }
            })
        },
        
    },
    mounted(){
        
    },
}
</script>
<style lang="scss" scoped>
.content {
    position: relative;
    background-color: #fff;
    padding: 0px 50px;
    min-height: 480px;
    .left-corner {
        line-height: 5px;
        border-bottom: #d6dde6 1px solid;
    }

    .words{
        font-size: 16px;
        line-height: 38px;
        text-align: left;
        font-family: Microsoft YaHei;
        margin-top: 42px;
        padding-bottom: 200px;
        .bannerbox,.iframebox{
            width: 100%;
        }
        strong{
            width: 100%;
            font-size: 28px;
            color: #333333;
            line-height: 40px;
            font-weight: 400;
        }
        ul{
            width:  100%;
            margin-left: -15px;
             li{
                list-style: none;
                display: inline;
                font-weight: 400;
                color: #666666;
                font-family: Microsoft YaHei;
                padding: 20px;
            }
        }
        .words2{
            width: 100%;
            text-align: left;
            font-weight: 400;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 38px;
            padding:0px 10px 10px;
        }
    }
}
.title{
    font-size: 28px;
    padding-bottom: 20px;
}
.downbox{
    margin: 30px 50px 50px;
    font-size: 16px;
    color: #E61F26;
    .downicon{
    position: relative;
    display: inline-block;
    padding-left: 22px;
    padding-bottom: 20px;
    margin-right: 30px;
  }
  .downicon::before{ 
    content: '';
    width: 18px;
    height: 20px;
    position: absolute;
    left: 0px;
    background: url('../../assets/img/index/tuanzhang.png') no-repeat center/100% auto;
  }
}
</style>